<template>
  <div>
    <h1>Új rendszerüzenet</h1>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
